module.exports = __webpack_public_path__ + "static/media/auth-left-mosaic.7f4f3bc5.png";